<template>
	<div class="score">
		<ICountUp
			class="score-nb"
			:startVal="0"
			:endVal="game.score"
			:decimals="0"
			:duration="0.5"
			:options="options"
		/>
		
		<transition-group name="gain-gem" tag="div" class="changings">
			<span v-for="destroyed_card in destroyed_cards" :key="destroyed_card.id" class="changing" :class="'position-' + destroyed_card.position">
				<div class="gem" :class="'value-' + destroyed_card.value"><icon file="gem" :size="16" /></div>
			</span>
		</transition-group>


		<tuto-info :step="2"></tuto-info>
		<tuto-info :step="6"></tuto-info>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ICountUp from 'vue-countup-v2';
import TutoInfo from './TutoInfo'

export default {
	name: 'Score',
	data () {
		return {
			endVal: 0,
			destroyed_cards: []
		}
	},
	computed: Object.assign(mapGetters([ 'last_chain', 'game', 'lang' ]), {
		options: function() {
			var options = {
				useEasing: true,
				useGrouping: true,
				separator: '',
				decimal: '.',
				prefix: '',
				suffix: ''
			}
			// if (this.lang == 'fr') options.separator = ' '
			return options
		}
	}),
	watch: {
		last_chain: function(last_chain, oldValue) {
			if (last_chain) {
				for (var i in last_chain) {
					var temp = {
						id: _.uniqueId('gems-'),
						position: last_chain[i].position,
						value: last_chain[i].card.value,
						animation: 'gain'
					};
					this.destroyed_cards.push(temp);
					this.$nextTick(function() {
						this.destroyed_cards.shift();
					})
				}
			}
		}
	},
	components: { ICountUp, TutoInfo }
}
</script>

<style lang="stylus">
@import '../../assets/css/app'
@import '../../assets/css/animations/gain-gem'


.score
	position absolute
	left 50%
	transform translate3D(-50%, 0, 0)
	font-size 64px
	bottom 48px
	text-align center
	height @font-size
	line-height @font-size
	color light
	z-index 2
	// color dark
	// text-shadow 0 -4px 2px alpha(dark, 100%)
	.score-nb
		display inline-block
		z-index 3
		height 40px
		background dark
		line-height @height
		box-shadow 0 0 16px 16px dark
		border-radius 100%
	.changings
		position absolute
		left calc(50% - 8px)
		top calc(50% - 8px)
		// transform translate3D(-50%, -50%, 0)
		color yellow
		z-index 2
		width 16px
		height 16px
		.changing
			position absolute
			left 0
			top 0
			width 16px
			height 16px
			.gem
				position absolute
				left 0
				top 0
				width 16px
				height 16px
				&.value-1
					color blue
				&.value-2
					color teal
				&.value-3
					color green
				&.value-4
					color yellow
				&.value-5
					color orange
				&.value-6
					color red
				&.value-7
					color pink
				&.value-8
					color purple
				&.value-9
					color gray
				.icon
					display block

</style>



// WEBPACK FOOTER //
// src/components/game/Score.vue